import { withStyles } from '@mui/styles';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import BlocActu from '../../../components/BlocActu';
import Button from '../../../components/Button';
import { formatDateCourt } from '../../../helpers/formatters';
import { useActualites } from '../../../hooks/useActualites';
import { traduction } from '../../../traductions';
import styles from './styles';

interface Props {
  classes?: any;
  langue: string;
}

interface Actu {
  datas: {
    title: string;
    intro: string;
    publication_date: string;
    type: {
      label: string;
    };
    url: string;
    img: string;
  };
}
function BureauxBloc(props: Props) {
  // const dispatch = useDispatch();
  const [cookies, setCookie] = useCookies();
  // const actualites: Actu = useSelector(state => Selectors.getActualitesDatas(state));

  const {mutate, error, data, isLoading} = useActualites();
  useEffect(() => {
    if (cookies['publicitaireIsCheck'] === 'true') {
      mutate(props.langue || 'fr')
    }
  }, [cookies]);

  const setCookies = () => {
    setCookie('publicitaireIsCheck', 'true');
  };
  return (
    <div className={props.classes.container}>
      <div className={props.classes.content}>
        <h2>{traduction(props.langue).actualites.titre}</h2>
        <div className={props.classes.contentActus}>
          {data ? (
            Object.values(data)
              .sort((a: any, b: any) => b.publication_date - a.publication_date)
              .map((actu: any) => (
                <BlocActu
                  langue={props.langue}
                  key={actu.title}
                  title={actu && actu.title}
                  text={actu.intro}
                  date={actu.publication_date && formatDateCourt(actu.publication_date)}
                  tag={actu.type.label}
                  link={actu.url}
                  image={actu.img}
                />
              ))
          ) : (
            <p>
              Les actualités ont été bloquées par vos préférences de cookies, pour Les réinitialiser,{' '}
              <Button
                variant="text"
                color="inherit"
                title="cliquez ici"
                onClick={setCookies}
                className={props.classes.buttonSimple}
              />
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default (withStyles(styles) as any)(BureauxBloc);
